"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
require("./profile.scss");
const snap_ui_1 = require("@teamsnap/snap-ui");
const bottom_buttons_1 = __importDefault(require("../bottom-buttons"));
const contact_info_fields_1 = __importDefault(require("../contact-info/contact-info-fields"));
const person_photo_thumb_1 = __importDefault(require("../person-photo-thumb"));
const form_section_contact_1 = __importDefault(require("./form-section-contact"));
const form_section_profile_1 = __importDefault(require("./form-section-profile"));
const form_section_visibility_1 = __importDefault(require("./form-section-visibility"));
const profile_form_fields_1 = __importDefault(require("./profile-form-fields"));
const api_1 = require("core/api");
const go_to_ts1_banner_1 = require("./go-to-ts1-banner");
class ProfileSettings extends React.Component {
    onSubmit = (values) => {
        const { online, submitProfileForm, 
        // submitContactForm,
        submitProfileSettings, loadHouseholds, initialValues, isUCIenabled, } = this.props;
        if (online) {
            // const initialProfileValues = initialValues.profile;
            const initialContactInfoValues = initialValues.contactInfos;
            const profileValues = values.profile;
            const contactValues = values.contactInfos;
            // const hasDirtyProfile = !isEqual(initialProfileValues, profileValues);
            const hasDirtyContacts = !(0, lodash_1.isEqual)(initialContactInfoValues, contactValues);
            const plainBirthdate = values.plainBirthdate;
            // we always want to submit the profile here, but only want to submit the
            // contact info if it has changes
            if (!hasDirtyContacts && !isUCIenabled) {
                // if there are only profile changes, only submit that form
                // for UCI rollout, we always want to submit both forms because some contacts fields are required
                return submitProfileForm(profileValues, false, false, plainBirthdate).then(() => {
                    return loadHouseholds();
                });
            }
            else {
                // submit both forms if they have changes
                return submitProfileSettings(profileValues, contactValues, false, false, plainBirthdate).then(() => {
                    return loadHouseholds();
                });
            }
        }
    };
    componentWillUnmount() {
        const { showSaveNeeded, dirty, submitting, reset, handleSubmit, history, contactInfoValues, submitContactFormIfMissingId, } = this.props;
        if (dirty) {
            const saveNeededData = {
                message: 'You have unsaved profile changes',
                saving: submitting,
                cancel: reset,
                onSave: handleSubmit(this.onSubmit),
                onSaveError: () => history.replace('/settings/profile'),
            };
            return showSaveNeeded(saveNeededData);
        }
        else {
            return submitContactFormIfMissingId(contactInfoValues);
        }
    }
    render() {
        const { handleSubmit, submitting, reset, selectedCountry, change, isUCIenabled, initialValues } = this.props;
        const ts1DisplayText = initialValues?.profile?.tsOneBanner?.message ?? 'Update your profile information in the TeamSnap ONE Dashboard';
        const goToTs1Link = initialValues?.profile?.tsOneBanner?.cta?.link ?? 'https://identity.teamsnap.com/profile';
        const showTs1Banner = initialValues?.profile?.capabilities?.includes(api_1.UserCapability.NAVIGATION_GO_TO_TS1);
        return !isUCIenabled ? (React.createElement("form", { id: "profile", onSubmit: handleSubmit(this.onSubmit), noValidate: true },
            React.createElement("div", { id: "profile-settings", className: "settings-section" },
                showTs1Banner && React.createElement(go_to_ts1_banner_1.GoToTs1Banner, { ctaUrl: goToTs1Link, ctaText: ts1DisplayText }),
                React.createElement("div", { id: "profile-info", className: "Panel" },
                    React.createElement("div", { className: "Panel-header" },
                        React.createElement("h3", { className: "Panel-title" }, "Profile Information")),
                    React.createElement("div", { className: "Panel-body" },
                        React.createElement("div", { className: "Panel-row Grid u-padNone" },
                            React.createElement("div", { className: "Panel-cell Panel-cell--header Grid-cell u-sizeFull u-xs-size8of24 u-sm-size6of24 u-textCenter u-padBottomLg u-borderBottom u-borderRightNone u-xs-borderRight u-xs-borderBottomNone" },
                                React.createElement("div", { className: "Profile-photo" },
                                    React.createElement(person_photo_thumb_1.default, null)),
                                React.createElement("h4", null, "Profile Photo"),
                                React.createElement("small", null, "Coming Soon...")),
                            React.createElement(redux_form_1.FormSection, { name: "profile" },
                                React.createElement(profile_form_fields_1.default, { change: change }))))),
                React.createElement("div", { id: "contact-info", className: "Panel" },
                    React.createElement("div", { className: "Panel-header" },
                        React.createElement("h3", { className: "Panel-title" }, "Contact Information")),
                    React.createElement("div", { className: "Panel-body" },
                        React.createElement("div", { className: "Panel-row Grid u-padNone" },
                            React.createElement("div", { className: "Panel-cell Panel-cell--header Grid-cell u-sizeFull u-xs-size8of24 u-sm-size6of24 u-borderBottom u-borderRightNone u-xs-borderRight u-xs-borderBottomNone" },
                                React.createElement("h4", null, "Primary Contact")),
                            React.createElement("div", { className: "Panel-cell Grid-cell u-sizeFull u-xs-size16of24 u-sm-size18of24" },
                                React.createElement(redux_form_1.FormSection, { name: "contactInfos" },
                                    React.createElement(contact_info_fields_1.default, { isSelf: true, selectedCountry: selectedCountry })))))),
                React.createElement(bottom_buttons_1.default, { id: "profile-buttons", submitting: submitting, onCancel: reset, onSubmit: handleSubmit(this.onSubmit) })))) : (React.createElement("form", { id: "profile", onSubmit: handleSubmit(this.onSubmit), noValidate: true, style: { maxWidth: '40rem', margin: 'auto' } },
            React.createElement(form_section_profile_1.default, null),
            React.createElement(form_section_contact_1.default, { selectedCountry }),
            React.createElement(form_section_visibility_1.default, null),
            React.createElement("div", { id: "profile-buttons", className: "sui-flex sui-justify-center" },
                React.createElement(snap_ui_1.LabelButton, { className: "sui-mr-2", variantType: "secondary", labelText: "Cancel", onClick: reset, disabled: submitting }),
                React.createElement(snap_ui_1.LabelButton, { variantType: "primary", labelText: "Save changes", onClick: handleSubmit(this.onSubmit), disabled: submitting }))));
    }
}
exports.default = (0, redux_form_1.reduxForm)({
    form: 'profile-settings',
    enableReinitialize: true, // to load initialValues
})(ProfileSettings);
